import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconEnterprise = createIcon({
  displayName: 'IconEnterprise',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M20 22H14V20H18V4H6V20H10V18H12V22H4V2H20V22ZM11 10H8V12H11V10ZM13 10H16V12H13V10ZM11 14H8V16H11V14ZM13 14H16V16H13V14ZM11 6H8V8H11V6ZM13 6H16V8H13V6Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
